import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { ApiservicesService } from '../services/apiservices.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-force-password-change',
  templateUrl: './force-password-change.component.html',
  styleUrls: ['./force-password-change.component.scss'],
})
export class ForcePasswordChangeComponent implements OnInit {
  loginForm: FormGroup;
  loader = false;
  session: any;
  errors: any = {};
  minute = 1;
  second = 59;
  disable = true;
  showTimeCount = true;
  hide = true;
  chide = true;
  private userIp: any = null;
  public env_name = environment.environment_name;

  constructor(
    private snackBar: MatSnackBar,
    private apiService: ApiservicesService,
    private cookieService: CookieService,
    private router: Router
  ) {
    this.loginForm = new FormGroup({
      password: new FormControl('', [
        Validators.required,
        Validators.pattern(
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!])(?!.*\s).{8,15}$/
        ),
      ]),
      cpassword: new FormControl('', [Validators.required]),
    });

    this.startTimer();
  }

  ngOnInit(): void {
    this.session = this.cookieService.get('session')
      ? JSON.parse(this.cookieService.get('session'))
      : {};

    this.apiService
      .getHttpDataWithoutBaseUrl('https://api.ipify.org?format=json')
      .subscribe({
        next: (getIpResp) => {
          console.log('getIpResp===========>', getIpResp);
          this.userIp = getIpResp?.ip ? getIpResp?.ip : '';
        },
      });
  }

  private startTimer() {
    const interval = setInterval(() => {
      if (this.second > 0) {
        this.second--;
      } else {
        if (this.minute === 0) {
          this.disable = false;
          this.showTimeCount = false;
          clearInterval(interval);
        } else {
          this.second = 59;
          this.minute--;
        }
      }
    }, 1000);
  }

  onSubmit() {
    this.loginForm.markAllAsTouched();

    if (!this.loginForm.valid) {
      this.validateErrors();
      return;
    }

    if (this.loginForm.value.password !== this.loginForm.value.cpassword) {
      this.snackBar.open('Password & Confirm Password do not match', 'OK', {
        duration: 5000,
      });
      return;
    }

    this.loader = true;

    const changePayload = {
      username: this.session.email,
      new_password: this.loginForm.value.password,
      session: this.session.token,
    };

    this.apiService
      .getHttpDataPostNoLogin('user/force-change-password', changePayload)
      .subscribe({
        next: (res: any) => {
          console.log('Change Password Response:', res);

          if (
            res.message ===
              'Password changed successfully and user logged in' &&
            res.status === 'success'
          ) {
            // this.snackBar.open(res.message, 'OK', { duration: 5000 });

            const loginPayload = {
              username: this.session.email,
              password: this.loginForm.value.password,
            };

            const ipUrl = `https://ipinfo.io/${
              this.userIp ? this.userIp : ''
            }?token=a8778567b02081`;

            this.apiService.getHttpDataWithoutBaseUrl(ipUrl).subscribe({
              next: (ipresponse) => {
                const finalLoginPayload = {
                  ...loginPayload,
                  ipInfo: ipresponse,
                };

                this.apiService
                  .getHttpDataPostNoLogin('user/login', finalLoginPayload)
                  .subscribe({
                    next: (response) => {
                      this.cookieService.set(
                        'login_user_details',
                        JSON.stringify(response.results),
                        { path: '/' }
                      );

                      this.cookieService.set('loggedin_user', 'true', {
                        path: '/',
                      });

                      // Optionally fetch astro toolkit (commented out)
                      // this.apiService
                      //   .getHttpData('astro_decan_new_infos/get-astro-toolkit')
                      //   .subscribe({
                      //     next: (astroResponse) => {
                      //       const obj = {
                      //         access_key: astroResponse.results.access_key,
                      //         secret_key: astroResponse.results.secret_key,
                      //       };
                      //       this.cookieService.set(
                      //         'astro_key_values',
                      //         JSON.stringify(obj),
                      //         { path: '/' }
                      //       );
                      //     },
                      //     error: (error) => {
                      //       console.log('Error fetching astro toolkit:', error);
                      //     },
                      //   });

                      this.loader = false;
                      this.snackBar.open('Password changed successfully and user logged in', 'Ok', {
                        duration: 3000,
                      });

                      const userType = response.results.userinfo.user_type;

                      if (userType === 'is_admin') {
                        const lastRoute = sessionStorage.getItem('lastroute');
                        if (lastRoute) {
                          this.router.navigateByUrl(`${lastRoute}`);
                          setTimeout(
                            () => sessionStorage.removeItem('lastroute'),
                            1500
                          );
                        } else {
                          this.router.navigateByUrl(`/admin-dashboard`);
                        }
                      } else if (
                        userType === 'is_astrologer' ||
                        userType === 'is_tarotreader'
                      ) {
                        this.router.navigateByUrl(`/astrologer-dashboard`);
                      } else if (
                        userType === 'is_social_advo' ||
                        userType === 'is_customer_socialadvo' ||
                        userType === 'is_customer'
                      ) {
                        this.router.navigateByUrl(`/customer-dashboard`);
                      } else if (userType === 'is_affiliate') {
                        this.router.navigateByUrl(`/affiate-dashboard`);
                      } else if (response.results.userinfo.is_diviner === 1) {
                        if (this.env_name === 'main') {
                          this.snackBar.open(
                            'This feature will be accessible to Diviner accounts starting February 1, 2026.',
                            'Ok',
                            { duration: 5000 }
                          );

                          this.cookieService.delete('login_user_details', '/');
                          this.cookieService.delete('loggedin_user', '/');
                        } else {
                          this.router.navigateByUrl(
                            `/divination-certification-dashboard`
                          );
                        }
                      } else if (
                        userType === 'is_Perennial_Mandalism' ||
                        response.results.userinfo.is_perennial_mandalism === 1
                      ) {
                        if (this.env_name === 'main') {
                          this.snackBar.open(
                            'You will be notified when access to this dashboard becomes available.',
                            'Ok',
                            { duration: 5000 }
                          );

                          this.cookieService.delete('login_user_details', '/');
                          this.cookieService.delete('loggedin_user', '/');
                        } else {
                          this.router.navigateByUrl(
                            `/perennial-mandalism-dashboard`
                          );
                        }
                      } else if (userType === 'customer') {
                        this.router.navigateByUrl(`/customer`);
                      }
                    },
                    error: (error) => {
                      this.loader = false;
                      console.log('Login error after password reset', error);

                      this.snackBar.open(
                        error.message || 'Login failed',
                        'Ok',
                        {
                          duration: 5000,
                        }
                      );
                    },
                  });
              },
              error: (ipError) => {
                this.loader = false;
                this.snackBar.open('Unable to fetch IP info', 'Ok', {
                  duration: 5000,
                });
              },
            });
          } else {
            this.snackBar.open(res.message || 'Something went wrong', '', {
              duration: 5000,
            });
            this.loader = false;
          }
        },
        error: (error) => {
          this.loader = false;

          this.snackBar.open(error.message || 'Something went wrong', '', {
            duration: 5000,
          });
        },
      });
  }

  private validateErrors() {
    const passwordControl = this.loginForm.get('password');
    const cpasswordControl = this.loginForm.get('cpassword');

    if (passwordControl?.invalid) {
      if (passwordControl.errors?.['required']) {
        this.errors.password = 'Password is required.';
      } else if (passwordControl.errors?.['pattern']) {
        this.errors.password =
          'Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one special character.';
      }
    } else {
      this.errors.password = '';
    }

    if (cpasswordControl?.invalid) {
      if (cpasswordControl.errors?.['required']) {
        this.errors.cpassword = 'Confirm Password is required.';
      }
    } else {
      this.errors.cpassword = '';
    }
  }

  ResetBack() {
    setTimeout(() => this.router.navigateByUrl('/login'), 2000);
  }

  goToPage(path: string) {
    this.router.navigateByUrl(path);
  }
}
